import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export default class PaginatorIntl extends MatPaginatorIntl {
  constructor() {
    super();

    this.firstPageLabel = 'Primeira página';
    this.lastPageLabel = 'Última página';
    this.nextPageLabel = 'Próxima página';
    this.previousPageLabel = 'Página anterior';
    this.itemsPerPageLabel = 'Itens por página:';
  }

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `Página 0 de 0`;
    }

    const pages = Math.ceil(length / pageSize);
    return `Página ${page + 1} de ${pages}`;
  };
}
